import {ActivatedRoute} from '@angular/router';
import {AssingSaleFormComponent} from './dialogs/assing-sale/assign-sale-form.component';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material';
import {SaleCommandsService} from '../services/sale-commands.service';
import {SimpleConfirmActionDialogComponent} from '../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../services/toast-messages.service';
import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';

@Component({
  styleUrls: ['./sale-details.component.scss'],
  templateUrl: './sale-details.component.html'
})
export class SaleDetailsComponent implements OnInit {
  private saleId: number;
  public dataSource: MatTableDataSource<Details>;
  public displayedColumns: string[] = ['serial_number', 'material_id', 'material_name', 'batch_name', 'model_name', 'weight_net', 'is_serial_received', 'phase_description'];
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  public title: string;
  public users: any;
  public responseDetails: any;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private saleCommandsService: SaleCommandsService,
              private toastMessagesService: ToastMessagesService) {
    this.users = [];
  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.params.subscribe((params) => {
      this.saleId = params.id;
    });

    this.responseDetails = await this.saleCommandsService.fetchSaleCommand(this.saleId);
    this.title = 'Πληροφορίες εντολής πώλησης';
    this.dataSource = new MatTableDataSource<Details>();
    this.dataSource.data = [this.responseDetails];
    this.users = await this.saleCommandsService.fetchUsersForAssign();
    await this.initUser();
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    await this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Αριθμός Εντολής',
          value: this.responseDetails.id
        }
      ],
      title: this.title
    };
    await this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];

    const action1 = {
      function: async () => {
        this.routeSaleCommand();
      },
      showAction: this.responseDetails.status_id === 1,
      title: `Ανάθεση Εντολής`,
      icon: 'assignment',
      color: 'black',
      tooltip: 'Η εντολή πρέπει να είναι εκκρεμής'
    };

    const action2 = {
      function: async () => {
        this.completeSale();
      },
      showAction: this.responseDetails.status_id === 3 || this.responseDetails.status_id === 10,
      title: `Ολοκλήρωση Εντολής`,
      icon: 'done',
      color: 'green',
      tooltip: 'Η εντολή πρέπει να είναι δρομολογημένη ή προς ολοκλήρωση'
    };

    const action3 = {
      function: async () => {
        this.reEvaluate();
      },
      showAction: this.responseDetails.status_id === 1 || this.responseDetails.status_id === 10,
      title: `Επαναξιολόγηση`,
      icon: 'repeat',
      tooltip: 'Η εντολή πρέπει να είναι εκκρεμής ή δρομολογημένη'
    };

    actions.push(action1);
    actions.push(action2);
    actions.push(action3);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  routeSaleCommand() {
    const dialog = this.matDialog.open(AssingSaleFormComponent, {
      data: {
        saleCommandId: this.saleId,
        users: this.users
      }
    });

    dialog.afterClosed().subscribe(async (response) => {
      if (response) {
        if (response.success) {
          try {
            const model = {
              id: response.id,
              user_id: response.user_id
            };
            await this.saleCommandsService.assignSaleCommand(model);
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στις εντολές πώλησης',
                redirectURL: `sale`
              }
            });
          } catch (e) {
            this.toastMessagesService.toastErrorMessage(`Η ενημέρωση απέτυχε. Λόγος: ${e.message}`);
          }
        } else {
          this.toastMessagesService.toastErrorMessage(`Η ενημέρωση απέτυχε.`);
        }
      }
    });
  }

  private completeSale() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Ολοκλήρωση Εντολής Φόρτωσης Πώλησης Ψυγείου',
        message: `Είστε σίγουροι ότι έχει παραληφθεί το ψυγείο ${this.responseDetails.serial_number} και θέλετε να ολοκληρώσετε την εντολή;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.saleCommandsService.completeSaleCommand(this.saleId);
          this.matDialog.open(ActionCompletionDialogComponent, {
            data: {
              buttonText: 'Πλοήγηση στις εντολές πώλησης',
              redirectURL: `sale`
            }
          });
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  private reEvaluate() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Επαναξιολόγηση Ψυγείου',
        message: `Είστε σίγουροι ότι θέλετε να θέσετε το ψυγείο με σειριακό ${this.responseDetails.serial_number} για επαναξιολόγηση;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const data = await this.commonService.updateObject(`refrigerator/re_evaluate`,
            {serial_number : this.responseDetails.serial_number});

          if (data.id) {
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στην εντολή συντήρησης',
                redirectURL: `repair_details/${data.id}`
              }
            });
          } else {
            this.toastMessagesService.toastMessages(`Η ενημέρωση του ψυγείου πραγματοποιήθηκε με επιτυχία`);
            location.reload();
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });

  }
}
